import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './config/axiosConfig';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Bloqueio de múltiplas abas (executa antes do React renderizar) ─────────
// Páginas públicas (ex.: /monitoramento) não são afetadas pelo bloqueio.
const _ehPaginaPublica = window.location.pathname.startsWith('/monitoramento');
const _tabIdExisting = sessionStorage.getItem('tabId');
const _isNewTab = !_tabIdExisting;
const _tabId = _tabIdExisting || (() => {
  const id = String(Date.now() + Math.random());
  sessionStorage.setItem('tabId', id);
  return id;
})();

const _tabChannel = new BroadcastChannel('gfinanc_tabs');

// Aba existente: responde a pings de novas abas (apenas páginas autenticadas)
_tabChannel.addEventListener('message', function(event) {
  if (_ehPaginaPublica) return;
  if (!event.data || event.data.tabId === _tabId) return;
  if (event.data.type === 'ping') {
    _tabChannel.postMessage({ type: 'pong', tabId: _tabId });
  }
});

function _renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
}

function _showBlockedPage() {
  sessionStorage.removeItem('tabId');
  document.getElementById('root').innerHTML =
    '<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;background:#f8f9fa;font-family:Arial,sans-serif">' +
      '<div style="text-align:center;padding:48px 40px;border-radius:12px;background:#fff;box-shadow:0 4px 20px rgba(0,0,0,.12);max-width:420px;width:90%">' +
        '<div style="font-size:56px;margin-bottom:16px">&#128274;</div>' +
        '<h2 style="color:#dc3545;margin:0 0 12px">Sistema j\u00e1 aberto</h2>' +
        '<p style="color:#6c757d;margin:0 0 28px;line-height:1.5">O sistema j\u00e1 est\u00e1 aberto em outra aba do navegador.<br>Feche a aba existente antes de usar esta.</p>' +
        '<button onclick="window.location.reload()" style="padding:10px 28px;background:#0d6efd;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:15px;font-weight:600">Tentar novamente</button>' +
      '</div>' +
    '</div>';
}

if (_ehPaginaPublica) {
  _renderApp();
} else if (_isNewTab) {
  let _blocked = false;
  const _onPong = function(event) {
    if (!event.data || event.data.type !== 'pong' || event.data.tabId === _tabId || _blocked) return;
    _blocked = true;
    _tabChannel.removeEventListener('message', _onPong);
    _showBlockedPage();
  };
  _tabChannel.addEventListener('message', _onPong);
  _tabChannel.postMessage({ type: 'ping', tabId: _tabId });

  setTimeout(function() {
    if (!_blocked) {
      _tabChannel.removeEventListener('message', _onPong);
      _renderApp();
    }
  }, 300);
} else {
  _renderApp();
}

// Detecta novo login em outra aba do mesmo navegador
window.addEventListener('storage', (event) => {
  try {
    if (event.key === 'token') {
      const oldToken = event.oldValue;
      const newToken = event.newValue;
      if (oldToken && newToken && oldToken !== newToken) {
        sessionStorage.setItem(
          'loginRedirectMessage',
          'Sua sessão foi encerrada porque um novo acesso foi realizado em outra aba ou janela deste navegador. Faça login novamente.'
        );
        window.location.href = '/';
      }
    }
  } catch (e) {
    // noop
  }
});

window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = event && event.reason;
    const msg = reason && (reason.message || String(reason));
    if (msg && msg.includes('Extension context invalidated')) {
      event.preventDefault();
      console.debug('Ignored extension error:', msg);
    }
  } catch (e) {
    // noop
  }
});
